import { ContainerPrivacyPolicy } from "./styled";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
  fetchData,
  selectIsLoading} from "../../../../mainApp/features/DataSlice/dataSlice";
  import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import LoadingPage from "../LoadingPage";
import ErrorPage from "../ErrorPage";

const AIButton = styled(NavLink)`
  display: inline-block;
  background-color: ${({ theme }) => theme.color.spotifyDarkGreen || "#1DB954"};
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyBrightGreen || "#17a34a"};
  }
`;

const RegulaminSection = styled.div`
  margin-bottom: 30px;
  
  h2 {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    border-bottom: 2px solid ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  
  h3 {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    margin-top: 25px;
    margin-bottom: 15px;
  }
  
  ol, ul {
    margin-left: 20px;
    margin-bottom: 15px;
  }
  
  li {
    margin-bottom: 8px;
    line-height: 1.6;
  }
  
  strong {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
  }
  
  .important {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
  }
  
  .contact-info {
    background-color: #e8f5e8;
    border: 1px solid #c3e6c3;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
  }
  
 
`;

function PrivacyPolicy({ showBackButton = true }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const location = useLocation();
  const [backButtonConfig, setBackButtonConfig] = useState({
    text: "Wróć do ustawień",
    path: "/settings/policy"
  });

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  let returned = "";

  switch (isLoading) {
    case "loading":
      returned = <LoadingPage />;
      break;
    case "success":
      returned = (
        <ContainerPrivacyPolicy isModal={!showBackButton}>
          {showBackButton && <AIButton to={"/settings/policy"}>Powrót</AIButton>}
          <h1 className="h1 text-center">Regulamin Aplikacji DragonscapeAI</h1>
          <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '30px' }}>
            obowiązuje od dnia 10.09.2025 r.
          </p>
          
          <RegulaminSection>
            <p>
              Niniejszy regulamin ("Regulamin") określa zasady i warunki świadczenia usług drogą elektroniczną za pośrednictwem aplikacji mobilnej i internetowej DragonscapeAI ("Aplikacja"), a także prawa i obowiązki Użytkowników oraz Usługodawcy.
            </p>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 1. Postanowienia ogólne</h2>
            <ol>
              <li>
                Właścicielem i administratorem Aplikacji jest <strong>Nowakowski Solutions - Miłosz Nowakowski</strong>, prowadzący działalność gospodarczą z siedzibą w Polsce, posługujący się numerami:
                <ul>
                  <li><strong>NIP:</strong> 5992652322</li>
                  <li><strong>REGON:</strong> 080081269</li>
                </ul>
                (dalej jako "Usługodawca").
              </li>
              <li>
                Kontakt z Usługodawcą jest możliwy za pośrednictwem adresu e-mail: <strong>kontakt@dragonscape.pl</strong>
              </li>
              <li>
                Regulamin jest udostępniany nieodpłatnie każdemu Użytkownikowi przed zawarciem umowy o świadczenie usług, w sposób umożliwiający jego pobranie, utrwalenie i odtworzenie. Akceptacja Regulaminu jest warunkiem koniecznym do korzystania z Aplikacji.
              </li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 2. Definicje</h2>
            <ul>
              <li><strong>Aplikacja</strong> – oprogramowanie DragonscapeAI dostępne na urządzenia mobilne oraz w wersji webowej, służące do generowania treści za pomocą sztucznej inteligencji.</li>
              <li><strong>Użytkownik</strong> – osoba fizyczna posiadająca pełną zdolność do czynności prawnych, która korzysta z Aplikacji po akceptacji Regulaminu i zawarciu umowy o świadczenie usług.</li>
              <li><strong>Konto</strong> – indywidualny profil Użytkownika w Aplikacji, zabezpieczony loginem i hasłem, umożliwiający dostęp do Usług.</li>
              <li><strong>Usługi</strong> – wszystkie funkcjonalności oferowane przez Usługodawcę w ramach Aplikacji, w tym tworzenie Konta, generowanie Treści przez AI oraz dostęp do płatnych subskrypcji.</li>
              <li><strong>Umowa</strong> – umowa o świadczenie usług drogą elektroniczną zawierana między Użytkownikiem a Usługodawcą z chwilą akceptacji Regulaminu.</li>
              <li><strong>API Zewnętrzne</strong> – interfejsy programistyczne dostarczane przez podmioty trzecie, wykorzystywane przez Aplikację do generowania treści, w tym API od OpenAI, getimg API, Suno API, oraz PiAPI.</li>
              <li><strong>Treści Generowane przez AI</strong> – wszelkie teksty, obrazy, dźwięki lub inne materiały wytworzone przez API Zewnętrzne na podstawie zapytań (promptów) Użytkownika.</li>
            </ul>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 3. Wymagania techniczne</h2>
            <p>Do prawidłowego korzystania z Aplikacji niezbędne jest:</p>
            <ul>
              <li>Posiadanie urządzenia z dostępem do internetu (komputer, smartfon, tablet).</li>
              <li>Zainstalowana aktualna wersja systemu operacyjnego (np. Android, iOS) lub przeglądarki internetowej (np. Chrome, Firefox, Safari).</li>
              <li>Aktywne konto e-mail.</li>
            </ul>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 4. Zakres i rodzaj Usług</h2>
            <ol>
              <li>Aplikacja umożliwia Użytkownikom generowanie różnorodnych treści (tekst, grafika, dźwięk) przy użyciu zintegrowanych API Zewnętrznych.</li>
              <li>Korzystanie z podstawowych funkcji Aplikacji może być bezpłatne, natomiast dostęp do zaawansowanych funkcjonalności lub zwiększonych limitów wymaga wykupienia płatnej subskrypcji.</li>
              <li>Usługi obejmują:
                <ul>
                  <li>Rejestrację i prowadzenie Konta Użytkownika.</li>
                  <li>Możliwość personalizacji profilu, w tym dodania imienia, nazwiska oraz zdjęcia profilowego.</li>
                  <li>Wprowadzanie zapytań (promptów) w celu generowania Treści przez AI.</li>
                  <li>Zarządzanie płatnymi subskrypcjami.</li>
                </ul>
              </li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 5. Zawarcie i rozwiązanie Umowy</h2>
            <ol>
              <li>Umowa o świadczenie usług zostaje zawarta z chwilą pomyślnego ukończenia procesu rejestracji w Aplikacji, co wymaga akceptacji niniejszego Regulaminu i Polityki Prywatności.</li>
              <li>Umowa zawierana jest na czas nieokreślony.</li>
              <li>Użytkownik może w każdej chwili rozwiązać Umowę poprzez usunięcie swojego Konta w ustawieniach Aplikacji.</li>
              <li>Usługodawca ma prawo rozwiązać Umowę z zachowaniem 14-dniowego okresu wypowiedzenia z ważnych przyczyn, takich jak zmiany technologiczne lub prawne.</li>
              <li>Usługodawca może rozwiązać Umowę ze skutkiem natychmiastowym lub zablokować Konto w przypadku rażącego naruszenia przez Użytkownika postanowień Regulaminu, w szczególności § 8.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 6. Konto Użytkownika</h2>
            <ol>
              <li>W celu utworzenia Konta, Użytkownik podaje swoje imię, nazwisko oraz adres e-mail. Opcjonalnie może dodać zdjęcie profilowe.</li>
              <li>Użytkownik jest zobowiązany do zachowania poufności swoich danych logowania i ponosi odpowiedzialność za wszelkie działania wykonane z użyciem jego Konta.</li>
              <li>Zabronione jest udostępnianie Konta osobom trzecim.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 7. Płatności</h2>
            <ol>
              <li>Dostęp do niektórych Usług (Subskrypcje) jest odpłatny. Wysokość opłat jest podana w cenniku dostępnym w Aplikacji.</li>
              <li>Operatorem płatności jest Stripe, Inc. Użytkownik, dokonując płatności, akceptuje regulamin świadczenia usług przez Stripe.</li>
              <li>Usługodawca nie przechowuje danych kart płatniczych Użytkownika. Dane te, wraz z danymi korespondencyjnymi czy firmowymi (NIP), są przetwarzane bezpośrednio przez Stripe w celu realizacji transakcji.</li>
              <li>Subskrypcje mają charakter odnawialny (miesięczny lub roczny). Użytkownik może anulować subskrypcję w dowolnym momencie w ustawieniach Konta, ze skutkiem na koniec bieżącego okresu rozliczeniowego.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 8. Prawa i obowiązki Użytkownika</h2>
            <ol>
              <li>Użytkownik zobowiązuje się do korzystania z Aplikacji w sposób zgodny z jej przeznaczeniem, prawem oraz dobrymi obyczajami.</li>
              <li>Użytkownik ponosi pełną odpowiedzialność za treść wprowadzanych zapytań (promptów).</li>
              <li>Kategorycznie zabrania się dostarczania treści o charakterze bezprawnym, w tym treści naruszających prawa autorskie, dobra osobiste, nawołujących do nienawiści, dyskryminacji, przemocy, a także treści pornograficznych, rasistowskich czy neofaszystowskich.</li>
              <li className="important">
                <strong>WAŻNE:</strong> Użytkownik zobowiązuje się do niewprowadzania do Aplikacji, w szczególności w zapytaniach (promptach) kierowanych do API Zewnętrznych, żadnych danych osobowych, w tym danych wrażliwych (np. o stanie zdrowia, poglądach politycznych), ani swoich, ani osób trzecich. Usługodawca nie monitoruje treści promptów i nie ponosi odpowiedzialności za ewentualne przekazanie takich danych do dostawców API Zewnętrznych.
              </li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 9. Odpowiedzialność Usługodawcy i charakter Treści Generowanych przez AI</h2>
            <ol>
              <li>Usługodawca dokłada wszelkich starań, aby Aplikacja działała w sposób ciągły i poprawny, jednak nie gwarantuje jej nieprzerwanej dostępności.</li>
              <li>Użytkownik przyjmuje do wiadomości, że Treści Generowane przez AI powstają w sposób zautomatyzowany i probabilistyczny. Usługodawca nie jest ich autorem i nie ma wpływu na ich ostateczny kształt.</li>
              <li>Usługodawca nie ponosi odpowiedzialności za Treści Generowane przez AI, w szczególności za ich dokładność, kompletność, zgodność z prawem czy ewentualną niestosowność (np. treści o charakterze obraźliwym, nagość). Usługodawca nie weryfikuje ani nie autoryzuje tych treści.</li>
              <li>Mimo stosowania dostępnych filtrów u dostawców API Zewnętrznych, istnieje ryzyko wygenerowania treści niepożądanych. Użytkownik korzysta z funkcji generowania treści na własne ryzyko.</li>
              <li>Odpowiedzialność Usługodawcy z tytułu niewykonania lub nienależytego wykonania Umowy jest ograniczona do wysokości opłat wniesionych przez Użytkownika za ostatnie 12 miesięcy korzystania z Usług, chyba że szkoda powstała z winy umyślnej Usługodawcy. Ograniczenie to nie dotyczy konsumentów.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 10. Prawa autorskie</h2>
            <ol>
              <li>Wszelkie prawa do Aplikacji, jej kodu, nazwy, logo, interfejsu graficznego oraz innych elementów stanowią własność Usługodawcy i podlegają ochronie prawnej.</li>
              <li>Użytkownik oświadcza, że posiada wszelkie prawa do treści wprowadzanych w zapytaniach (promptach).</li>
              <li>Z chwilą wygenerowania Treści przez AI, Usługodawca udziela Użytkownikowi niewyłącznej, nieograniczonej terytorialnie i czasowo licencji na korzystanie z tych treści na następujących polach eksploatacji: utrwalanie, zwielokrotnianie, wprowadzanie do obrotu, publiczne udostępnianie, a także modyfikowanie. Licencja obejmuje prawo do wykorzystania komercyjnego.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 11. Postępowanie reklamacyjne</h2>
            <ol>
              <li>Reklamacje dotyczące działania Aplikacji należy składać na adres e-mail podany w § 1 ust. 2.</li>
              <li>Zgłoszenie reklamacyjne powinno zawierać dane Użytkownika oraz szczegółowy opis problemu.</li>
              <li>Usługodawca rozpatrzy reklamację w terminie 14 dni od jej otrzymania i poinformuje Użytkownika o wyniku postępowania.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 12. Ochrona danych osobowych</h2>
            <ol>
              <li>Administratorem danych osobowych Użytkowników jest Usługodawca.</li>
              <li>Dane osobowe przetwarzane są w celu realizacji Umowy oraz na podstawie zgody Użytkownika.</li>
              <li>Szczegółowe informacje na temat przetwarzania danych osobowych, w tym cele, podstawy prawne, okres przechowywania, prawa Użytkownika oraz informacje o odbiorcach danych (w tym Firebase i Stripe) znajdują się w Polityce Prywatności, która stanowi integralną część niniejszego Regulaminu.</li>
            </ol>
          </RegulaminSection>

          <RegulaminSection>
            <h2>§ 13. Postanowienia końcowe</h2>
            <ol>
              <li>Usługodawca zastrzega sobie prawo do zmiany Regulaminu z ważnych przyczyn (np. zmiana przepisów prawa, wprowadzenie nowych Usług). O zmianach Użytkownik zostanie poinformowany drogą mailową lub poprzez komunikat w Aplikacji z co najmniej 14-dniowym wyprzedzeniem.</li>
              <li>W sprawach nieuregulowanych w Regulaminie zastosowanie mają przepisy prawa polskiego.</li>
              <li>Wszelkie spory będą rozstrzygane w pierwszej kolejności polubownie. W przypadku braku porozumienia, sądem właściwym będzie sąd właściwy dla siedziby Usługodawcy, a w przypadku konsumentów – sąd właściwy według przepisów ogólnych.</li>
            </ol>
          </RegulaminSection>
        </ContainerPrivacyPolicy>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default PrivacyPolicy;